import { objects } from '@swuif/utils';
export var isI18nReady = function isI18nReady(i18n) {
  return !objects.isEmpty(i18n) && i18n.t != null;
};
export var createMeta = function createMeta(meta) {
  return Object.keys(meta).reduce(function (a, b) {
    var _meta$b = meta[b],
        countryFlag = _meta$b.countryFlag,
        label = _meta$b.label;
    a[b] = {
      countryFlag: countryFlag,
      label: label
    };
    return a;
  }, {});
};